import { withViewComponent } from '@updater-legacy/components/custom-element';
import { ENVIRONMENT } from '../../../environment/';
import './components/circle';
import './components/checkmark';
import './components/offer-details';
import gql from 'graphql-tag';
import { fetchGraphQLQuery } from '../../../helpers/graphql';
import { RECEIVE, SUBMIT } from '@updater-core/lib/tracker';

const offers = [
  {
    id: 'standard',
    name: 'Standard Protection',
    price: '27.99',
    installPrice: '99',
    features: ['ADT 24/7 Monitoring', 'Digital Keypad', 'Entryway Contacts'],
    bonuses: ['FREE $100 Amazon Gift Card'],
    featureHeader: 'Features Include:',
    extraFeatureHeader: '',
    extraFeatures: [
      'Pet Sensitive Motion Detector',
      'Backup Battery',
      'Yard Sign & Window Decals',
    ],
    provider: {
      name: 'ADT',
      logo: 'safestreets_adt_logo.jpg',
    },
    tooltip:
      '$99.00 Customer Installation Charge. 36-Month Monitoring Agreement required at $36.99 per month ($1,331.64). 24-Month Monitoring Agreement required at $36.99 per month ($887.76) for California. Form of payment must be by credit card or electronic charge to your checking or savings account. Offer applies to homeowners only. Local permit fees may be required. Satisfactory credit history required. Certain restrictions may apply. Offer valid for new ADT Authorized Dealer customers only and not on purchases from ADT LLC. Other rate plans available. Cannot be combined with any other offer.',
  },
  {
    id: 'premium',
    name: 'Premium Protection',
    price: '44.99',
    installPrice: '99',
    features: ['Cellguard'],
    extraFeatures: [
      'Smoke Detector',
      'Carbon Monoxide Detector',
      'Flood Detector',
      'Shock Sensors',
      'Glass Break Sensors',
    ],
    bonuses: ['FREE $100 Amazon Gift Card', 'FREE 12 Wireless Entry Contacts'],
    featureHeader: 'Features Everything in Standard Protection. PLUS:',
    extraFeatureHeader: 'Available with plans $36.99 & Up:',
    provider: {
      name: 'ADT',
      logo: 'safestreets_adt_logo.jpg',
    },
    tooltip:
      '$99.00 Customer Installation Charge. 36-Month Monitoring Agreement required at $36.99 per month ($1,331.64). 24-Month Monitoring Agreement required at $36.99 per month ($887.76) for California. Form of payment must be by credit card or electronic charge to your checking or savings account. Offer applies to homeowners only. Local permit fees may be required. Satisfactory credit history required. Certain restrictions may apply. Offer valid for new ADT Authorized Dealer customers only and not on purchases from ADT LLC. Other rate plans available. Cannot be combined with any other offer.',
  },
  {
    id: 'professional',
    name: 'Professional Protection',
    price: '62.99',
    installPrice: '199',
    features: [
      'Remote Web & Mobile Access',
      'Remote Arm/Disarm',
      'Email & Text Notifications',
    ],
    extraFeatures: [
      'ADT Doorbell Camera',
      'Indoor Camera',
      'Outdoor Camera',
      'Remote Door Lock',
      'Remote Light Module',
      'Remote Thermostat',
      'Garage Door Control',
    ],
    bonuses: [
      'FREE $100 Amazon Gift Card',
      'FREE ADT Doorbell Camera',
      'FREE Door Lock',
    ],
    featureHeader: 'Everything in Premium Protection, PLUS:',
    extraFeatureHeader: 'Available with plans $62.99 & Up:',
    provider: {
      name: 'ADT',
      logo: 'safestreets_adt_logo.jpg',
    },
    tooltip:
      '$199.00 Customer Installation Charge. 36-Month Monitoring Agreement required at $36.99 per month ($1,331.64). 24-Month Monitoring Agreement required at $36.99 per month ($887.76) for California. Form of payment must be by credit card or electronic charge to your checking or savings account. Offer applies to homeowners only. Local permit fees may be required. Satisfactory credit history required. Certain restrictions may apply. Offer valid for new ADT Authorized Dealer customers only and not on purchases from ADT LLC. Other rate plans available. Cannot be combined with any other offer.',
  },
];

const styles = `
  .banner {
    color: white;
    background-color: #80acc2;
    padding: 0.5em;
    text-align: center;
  }

  a {
    color: white;
    font-weight: 900;
    text-decoration: none;
  }

  .body {
    margin: 1em auto 0 auto;
    display: flex;
    width: 1200px;
  }

  .info {
    max-width: 300px;
    min-width: 285px;
  }

  .offers {
    padding-left: 2em;
  }

  h1, h2 {
    margin: 0;
  }

  h1 {
    font-size: 1.5em;
    font-weight: 300;
    padding: 0.5em 0 0.33em 0;
    border-bottom: 1px solid black;
  }

  h2 {
    font-size: 1em;
    font-weight: 300;
    padding: 1em 0;
  }

  h2 a {
    color: #2b7499;
  }

  .gift-card {
    border: 1px solid #efefef;
    border-radius: 4px;
    position: relative;
  }

  .gift-card img {
    object-fit: none;
    height: 100px;
    width: 100%;
  }

  upd-home-security-circle {
    height: 70px;
    width: 70px;
    border: 2px solid #aac7d6;
    color: white;
    position: absolute;
    top: 8px;
    left: 8px;
  }

  upd-card {
    margin-top: 1em;
  }

  upd-card .card-body {
    padding: 1em;
  }

  upd-card .header {
    font-size: 1.5em;
    border-bottom: 1px solid black;
    margin-bottom: 0.5em;
  }

  a[slot="footer"] {
    display: block;
    padding: 1em;
    font-size: .75em;
    color: #2b7499;
    font-weight: 900;
    text-decoration: none;
  }

  @media (max-width: 1249px) {
    .body {
      width: 1000px;
    }
  }

  @media (max-width: 1000px) {
    .banner {
      display: none;
    }

    .body {
      flex-direction: column;
      align-items: center;
      position: relative;
      width: calc(100% - 32px);
      margin: 1em;
      padding-bottom: 400px;
    }

    upd-card {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .info {
      min-width: 0;
    }

    .offers, .info {
      padding-left: 0;
      max-width: 600px;
      width: 100%;
    }
  }

  @media (min-width: 632px) and (max-width: 1000px) {
    upd-card {
      width: 600px;
      left: auto;
      right: auto;
    }
  }
`;

const bullets = [
  'Lower insurance premium',
  'Enjoy 24/7 monitoring',
  'Employ 140+ years experience',
  'Get professional installation',
  'Customize to your liking',
  'Control your security',
];

const query = gql`
  mutation reserveHomeSecurityPackage(
    $input: MakeHomeSecurityReservationInput!
  ) {
    makeHomeSecurityReservation(input: $input) {
      reservation {
        confirmationNumber
      }
    }
  }
`;

export default class SecurityLandingPage extends withViewComponent(styles)() {
  onselect = ({ detail: { packageName } }) => {
    this.tracker.track({
      verb: SUBMIT,
      object: 'make_reservation',
      payload: {
        packageName,
      },
    });

    fetchGraphQLQuery({
      headers: this.sessionHeaders,
      query,
      url: `${ENVIRONMENT.endpoints.api.url}/graphql`,
      variables: {
        input: {
          moveId: this.moveId,
          package: packageName,
        },
      },
    }).then(({ data }) => {
      this.dispatchEvent(
        new CustomEvent('upd-home-security-reservation', {
          bubbles: true,
          composed: true,
        })
      );
      const confirmationNumber =
        data.makeHomeSecurityReservation.reservation.confirmationNumber;

      this.tracker.track({
        verb: RECEIVE,
        object: 'confirmation_number',
        payload: {
          confirmationNumber,
        },
      });
      // We need to tell the mover-app state the the item state has changed due
      // to the graphql call.
      this.stateInterface.updateItemState().then(() => {
        this.router.goTo('/reserved?confirmationNumber=' + confirmationNumber);
      });
    });
  };

  constructor(router, value) {
    super();
    this.router = router;
    Object.assign(this, value);
  }

  connected() {
    this.render`
      <div class="banner">
        Call your Updater moving specialist to receive expert consultation and your exclusive offer.
        <a
          href="tel:8334280496"
          data-analytics-on
          data-analytics-event="Call Banner"
        >
          (833) 428-0496
        </a>
      </div>
      <div class="body">
        <div class="info">
          <div class="gift-card">
            <img
              src=${`${ENVIRONMENT.endpoints.cloudinary}/c_fill,w_285/amaz_giftcard_promotion_logo.jpg`}
            />
            <upd-home-security-circle>
              <img src=${`${ENVIRONMENT.endpoints.cloudinary}/adt_logo.svg`}/>
            </upd-home-security-circle>
            <div style="padding: 1em; color: #56b784">
              Every ADT purchase includes a $100 Amazon gift card from Updater
            </div>
          </div>
          <upd-card>
            <div class="card-body">
              <div class="header">Why home security?</div>
              ${bullets.map(
                (bullet) => this.wire(bullet)`
                <div class="bullet">
                  <upd-home-security-checkmark />
                    ${bullet}
                </div>
              `
              )}
            </div>
            <a
              href="https://www.updater.com/moving-tips/home-security-systems"
              target="_blank"
              rel="noopener"
              slot="footer"
            >
              Read our how-to guide for buying home security packages.
            </a>
          </upd-card>
        </div>
        <div class="offers">
          <h1>Popular Packages</h1>
          <h2>
            Call
            <a
              href="tel:8334280496"
              data-analytics-on
              data-analytics-event="Call Footer"
            >
              (833) 428-0496
            </a>
            to receive expert consultation on these security packages.
          </h2>
          ${offers.map(
            (o) =>
              this.wire(o.name)`<upd-home-security-offer-details offer=${o} />`
          )}
        </div>
      </div>
    `;
  }
}

customElements.define('upd-home-security-landing-page', SecurityLandingPage);
